import { Box, Container, Typography } from '@mui/material'
import {
    MapPaymentIcon,
    mapPaymentTypeName,
} from 'components/MapPaymentIcon/mapPaymentIcon'
import MonetaryFormat from './MonetaryFormat'
import { isUndefined } from 'lodash-es'
import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'

const PaymentDetailsPage = () => {
    const { paymentPayload: paymentDetail } = useCFDContext()

    return (
        <Container sx={(x) => ({ background: x.palette.background.paper })}>
            <Box
                alignContent={'center'}
                height={'100vh'}
                justifyContent={'center'}
                display={'flex'}
                flexDirection={'column'}
                sx={(x) => {
                    return { height: '97svh' }
                }}
            >
                {!isUndefined(paymentDetail?.paymentTypeID) && (
                    <Typography variant="h4" fontWeight={600} align={'center'}>
                        {mapPaymentTypeName(paymentDetail?.paymentTypeID!)}
                    </Typography>
                )}

                {paymentDetail?.image ? (
                    <Box py={3} component={Typography} align={'center'}>
                        <img
                            alt="payment_image"
                            width={'70%'}
                            src={paymentDetail?.image}
                        />
                    </Box>
                ) : (
                    !isUndefined(paymentDetail?.paymentTypeID) && (
                        <Box py={3} component={Typography} align={'center'}>
                            <MapPaymentIcon
                                size={50}
                                paymentTypeId={paymentDetail?.paymentTypeID!}
                            />
                        </Box>
                    )
                )}
                {!isUndefined(paymentDetail?.totaldue) && (
                    <Typography
                        py={2}
                        variant="h4"
                        fontWeight={600}
                        align={'center'}
                    >
                        TOTAL:{' '}
                        <MonetaryFormat
                            variant="inherit"
                            component="span"
                            value={paymentDetail?.totaldue}
                        />
                    </Typography>
                )}

                {paymentDetail?.accountName && (
                    <Typography pb={2} variant="h5" align={'center'}>
                        Account: {paymentDetail?.accountName}
                    </Typography>
                )}
                {!isUndefined(paymentDetail?.accountBalance) && (
                    <Typography pb={2} variant="h5" align={'center'}>
                        Account Balance:{' '}
                        <MonetaryFormat
                            variant="inherit"
                            component="span"
                            value={paymentDetail?.accountBalance}
                        />
                    </Typography>
                )}

                {paymentDetail?.message && (
                    <Typography pt={3} variant="h6" align={'center'}>
                        {paymentDetail?.message}
                    </Typography>
                )}
            </Box>
        </Container>
    )
}

export default PaymentDetailsPage
